let React      = require('react');

import ContentsModal from 'contents_modal';
import Sanitize      from '@utils/sanitize';
// -------------------------------------------------------

class BasicModal extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    let flg = (this.props.modal_active === true) ? true : false;
    this.state = {
      modal: flg,
    };
  }
  // -------------------------------------------------------
  
  showModal(flg) {
    this.setState({ modal: true });
  }
  // -------------------------------------------------------
  
  closeModal() {
    if( this.props.close_ev != undefined ){
      this.props.close_ev.bind(this)();
    } else {
      this.setState({ modal: false });
    }
  }
  // -------------------------------------------------------
  
  render() {
    let title = this.props.title;
    
    let sub_title = this.props.sub_title;
    if( sub_title == undefined ) sub_title = '';
    try { sub_title = Sanitize.nl2br(sub_title); } catch(e) {}
    
    let buttons = this.props.buttons;
    
    let contents = this.props.contents;
    let contents_height = this.props.contents_height;
    if( contents_height == undefined ) contents_height = 0;
    
    let width  = (this.props.width == undefined) ? 450 : this.props.width;
    let height = (this.props.height == undefined) ? 150 : this.props.height;
    height += contents_height;
    
    let title_size = this.props.title_size;
    if( title_size == undefined ) title_size = 16;
    
    // サブローディング処理;
    return (
      <div className="basic-modal-contents">
        { (this.props.html != undefined) &&
          <div onClick={this.showModal.bind(this, true)}>
            {this.props.html}
          </div>
        }
        
        <ContentsModal
          view      = {this.state.modal}
          width     = {width}
          height    = {height}
          close_ev  = {this.closeModal.bind(this)}
          html      = {
            <div className="modal-item basic-modal">
              <h2 style={{ fontSize: title_size }}>{title}</h2>
              { (typeof sub_title == 'string')
                ? <h4 dangerouslySetInnerHTML={{ __html: sub_title }} />
                : <h4>{sub_title}</h4>
              }
              
              { (contents != undefined && contents != null) &&
                <div className="contents-box" style={{ height: contents_height }}>
                  {contents}
                </div>
              }
              
              { (buttons.length > 0)
                ? <div className="yes-no">
                    { buttons.map((d, key) => {
                      if( d.html != undefined ) return React.cloneElement(d.html, { key: key });
                      
                      let event = d.event;
                      if( event == undefined ) event = this.closeModal.bind(this);
                      return <div key={key} className={'button '+ d.id} onClick={event}>{d.name}</div>
                    })}
                  </div>
                : <p />
              }
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default BasicModal;